export var ACTION;
(function (ACTION) {
    ACTION["TRANSACTION"] = "TRANSACTION";
    ACTION["NAVIGATION"] = "NAVIGATION";
    ACTION["GO_TO_EMAIL"] = "GO_TO_EMAIL";
    ACTION["MENU"] = "MENU";
    ACTION["HIDE_POPUP"] = "HIDE_POPUP";
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["CLOSE_LOADER"] = "CLOSE_LOADER";
    ACTION["GO_TO_REPAYMENT"] = "GO_TO_REPAYMENT";
})(ACTION || (ACTION = {}));
